@if (configuration) {
  @if (data) {
    <sidebar-main-container data-test-id="sidebarTableViewMainContainer">
      <smc-sidebar>
        <ng-container sidebarLabel>
          {{ configuration.sidebar.label }}
        </ng-container>
        @if (data.sidebar) {
          <ng-container sidebarBody>
            @for (
              attribute of configuration.sidebar.attributes;
              track attribute
            ) {
              <model-attribute
                [context]="data.sidebar"
                [config]="attribute"
                direction="column"
              >
              </model-attribute>
            }
          </ng-container>
        }
      </smc-sidebar>
      <smc-main [footerConfig]="configuration.footer">
        <ng-container mainContent>
          @if (
            configuration.backButton?.content && configuration.backButton?.route
          ) {
            <section class="stv__main__back">
              <zip-button
                level="text"
                icon="chevron_left"
                [content]="configuration.backButton.content"
                (zipButtonClicked)="clickBackButton($event)"
                data-test-id="sidebarTableViewBackButton"
              >
              </zip-button>
            </section>
          }
          <div class="stv__main__header">
            <div class="stv__main__title">
              <h4 class="t-bold" data-test-id="sidebarTableViewMainHeaderTitle">
                {{ data.title }}
              </h4>
            </div>
            @if (configuration.filters) {
              <div class="u-flex u-alignCenter u-justifyEnd u-fillRemaining">
                <!-- TODO: mobile filter/search -->
                <div class="stv__filters--mobile">
                  <icon
                    name="tune"
                    [config]="{ type: 'pointer' }"
                    data-test-id="sidebarTableViewMobileFiltersIcon"
                  >
                  </icon>
                </div>
                <div class="stv__filters--desktop">
                  @for (filter of configuration.filters; track filter) {
                    <form-control
                      [ngStyle]="{ 'grid-column': filter.grid?.col }"
                      [group]="form"
                      [control]="getFilterControl(filter.prop)"
                      [config]="filter"
                      direction="filter"
                    >
                    </form-control>
                  }
                </div>
              </div>
            }
          </div>
          @if (configuration.tabs && configuration.activeTab) {
            <section class="stv__main__tabs">
              <tabs
                [tabLabels]="configuration.tabLabels"
                (tabSelected)="setActiveTab($event)"
              >
                @for (tab of configuration.tabs; track tab) {
                  <div *templateRef>
                    @if (tab === configuration.activeTab) {
                      <ng-template [ngTemplateOutlet]="stvTable"></ng-template>
                    }
                  </div>
                }
              </tabs>
            </section>
          }
          @if (!configuration.tabs) {
            <section class="stv__main__table">
              <!-- #stvTable -->
              <ng-template [ngTemplateOutlet]="stvTable"></ng-template>
            </section>
          }
          <ng-template #stvTable>
            <datagrid
              [config]="configuration.datagrid"
              [data]="data.datagrid"
              (datagridRowSelected)="setActiveRow($event)"
              (actionClicked)="clickAction($event)"
            >
            </datagrid>
            @if (configuration.paginator && data.datagrid) {
              <footer class="stv__main__table__footer">
                <paginator
                  [config]="configuration.paginator"
                  [data]="data.datagrid"
                  (pageSelected)="setCurrentPage($event)"
                >
                </paginator>
              </footer>
            }
          </ng-template>
        </ng-container>
      </smc-main>
    </sidebar-main-container>
  }
}

<!-- Missing Configuration -->
<ng-template #noConfig>
  <div
    class="u-flex u-alignCenter u-justifyCenter u-column"
    data-test-id="sidebarTableViewNotFoundContainer"
  >
    @if (configuration.datagrid.noData.imageUrl) {
      <img
        [src]="configuration.datagrid?.noData?.imageUrl"
        [attr.alt]="configuration.datagrid?.noData?.message"
      />
    }
    <p class="t-data t-bold">Page Not Found</p>
    <p class="t-data">You're gonna go out there, drink your drink,</p>
    <p class="t-data">say, "Goodnight, I've had a very lovely evening",</p>
    <p class="t-data">
      <a
        class="t-data t-link t-bold"
        routerLink="/home"
        data-test-id="sidebarTableViewHomeLink"
        >go home</a
      >
      ... and that's all you're gonna do.
    </p>
  </div>
</ng-template>
<!-- / Missing Configuration -->
